import { render, staticRenderFns } from "./VFile.vue?vue&type=template&id=63886d4f&scoped=true"
import script from "./VFile.vue?vue&type=script&lang=js"
export * from "./VFile.vue?vue&type=script&lang=js"
import style0 from "./VFile.vue?vue&type=style&index=0&id=63886d4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63886d4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFileInput,VIcon})
